// hooks/useIsSmallMobile.ts
import { useEffect, useState } from 'react';
import { smallMobile } from '../utils/resolution';

const useIsSmallMobile = (breakpoint: number = smallMobile) => {
  const [isSmallMobile, setIsSmallMobile] = useState(() => window.innerWidth <= breakpoint);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallMobile(window.innerWidth <= breakpoint);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // ensure value is accurate on mount

    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isSmallMobile;
};

export default useIsSmallMobile;
